import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "weather-n",
  "use": "weather-n-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up\" id=\"weather-n\"><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"5\" /><polyline points=\"5 12 12 5 19 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol